import React, { FC, ReactElement, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { ResponsiveLayout } from 'common/components/ResponsiveLayout_V2'
import { ROUTES } from 'common/constants'
import { deleteMyUser } from 'features/Auth/actions'
import { getAuth } from 'features/Auth/selectors'
import { AppLayout } from 'features/Layout/AppLayout'
import { getMyUid } from 'features/MyProfile/selectors'
import { DeleteAllDataModal } from 'features/Settings/DeleteAllDataModal'
import { SettingsMenu } from 'features/Settings/SettingsMenu'
import styles from './styles.module.sass'

interface ISettings {
  children: ReactElement
}

export const Settings: FC<ISettings> = ({ children }) => {
  const dispatch = useDispatch()
  const myUid = useSelector(getMyUid)
  const [isDeleteLoading, setIsDeleteLoading] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const auth = useSelector(getAuth)

  const onDeleteUser = () => {
    setIsDeleteLoading(true)
    dispatch(deleteMyUser(myUid))
  }

  if (auth === false) {
    return <Redirect to={ROUTES.AUTH} />
  }

  return (
    <AppLayout>
      <div className={styles.container}>
        <ResponsiveLayout
          leftContent={(
            <SettingsMenu
              setIsDeleteModalOpen={setIsDeleteModalOpen}
              isDeleteModalOpen={isDeleteModalOpen}
            />
          )}
          rightContent={children}
          responsiveLayoutLeft={styles.responsiveLayoutLeftStyles}
          responsiveLayoutRight={styles.responsiveLayoutRightStyles}
          isRightContentEmpty={false}
          isLeftHiddenOnMobile
          isLeftWithHeader
        />
        <DeleteAllDataModal
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onSubmit={onDeleteUser}
          isDeleteLoading={isDeleteLoading}
        />
      </div>
    </AppLayout>
  )
}
